<template>
  <div class="invoice-view" >
    <!-- <div class="pdf-test">
      <h2>Hello Test PDF</h2>
      <p>
        This is a minimal test to generate a PDF blob and share or download.
      </p>
      <v-btn color="primary" @click="generatePDF">Share as PDF</v-btn>

      <div
        ref="testElement"
        style="margin-top: 20px; padding: 20px; border: 1px solid #ccc"
      >
        <h3>Sample Invoice</h3>
        <p>Customer: John Doe</p>
        <p>Total: $123.45</p>
      </div>
    </div> -->
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else-if="linkExpired">
      <LinkExpiredPage />
    </div>
    <div v-else >
      <v-card flat v-if="currentBusiness">
        <PrintViewBar
          v-if="Invoice"
          :showEmailBtn="showEmailBtn"
          :id="Invoice.id"
          :component="'InvoiceView'"
          type="invoice"
          :title="`Invoice # ${this.Invoice.localId}`"
          :postfix="`view?key=${currentBusiness.code}`"
          :name="currentBusiness.name"
          :email="Invoice.Customer.email"
          :obj="Invoice.Customer"
          @generatePDF="generatePDF"
          @print="print"
          :text="`Invoice from ${currentBusiness.name} click the link to view`"
        />
        <!-- currentBusiness: {{ currentBusiness.name }} -->
        <InvoiceReceipt v-if="this.currentBusiness.metadata && this.currentBusiness.metadata.invoiceViewFormat && Invoice" :invoice="Invoice" :actions="true" :smallScreen=true @pdfDocument="pdfDocument">
        </InvoiceReceipt>
        <HtmlInvoice v-else-if="Invoice" :Invoice="Invoice" />
      </v-card>
    </div>
  </div>
</template>

<script>
import PrintViewBar from "@/components/PrintViewBar";
import LinkExpiredPage from "./LinkExpired.vue";
import invoiceService from "@/modules/Invoice/service.js";
import HtmlInvoice from "@/modules/Invoice/bigInvoice/htmlInvoice.vue";
import InvoiceReceipt from '@/modules/Invoice/components/InvoiceReceipt.vue';
import html2pdf from "html2pdf.js";
import Hashids from "hashids";
import { mapGetters, mapActions } from "vuex";
import pdfMake from 'pdfmake/build/pdfmake.min';
const hashids = new Hashids();

export default {
  data() {
    return {
      showEmailBtn: false,
      isLoading: true,
      doc: null,
      linkExpired: false,
      Invoice: {
        InvoiceDetails: [],
      },
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },
  async created() {
    if (this.$route.meta.public) {
      await this.loadPublicData();
    } else {
      await this.loadData();
      if (!this.currentBusiness) {
        await this.initUser();
      }
    }

  },
  components: {
    PrintViewBar,
    LinkExpiredPage,
    InvoiceReceipt,
    HtmlInvoice
  },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    pdfDocument(doc){
      this.doc = doc
    },
    print() {
      pdfMake.createPdf(this.doc).print({}, window)
    },
    generatePDF() {
      const element = this.$refs.testElement;
      // console.log("element:", element);

      html2pdf()
        .from(element)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          // console.log("Got jsPDF instance:", pdf);
          const blob = pdf.output("blob");
          // console.log("Output blob:", blob);

          const file = new File([blob], `Invoice-${this.Invoice.localId}.pdf`, {
            type: "application/pdf",
          });
          // console.log("Created File object:", file);

          if (
            navigator.share &&
            navigator.canShare &&
            navigator.canShare({ files: [file] })
          ) {
            console.log("Sharing with navigator.share...");
            navigator
              .share({
                title: `Invoice # ${this.Invoice.localId}`,
                text: `here is your invoice from ${this.currentBusiness.name}`,
                files: [file],
              })
              .catch((err) => console.error("Share failed:", err));
          } else {
            console.log("Sharing not supported. Downloading instead.");
            html2pdf()
              .from(element)
              .set({
                margin: [0.5, 0.5, 2.0, 0.5],
                filename: `Invoice-${this.Invoice.localId}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                pagebreak: { mode: "avoid-all" },
                html2canvas: { scale: 1.5, logging: true },
                jsPDF: {
                  unit: "in",
                  format: [8.5, 30],
                  orientation: "portrait",
                },
              })
              .save();
          }
        });
    },
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;
      return invoiceService
        .publicGetById(id, { invoice: true, key: key })
        .then((response) => {
          // console.log("response invoice", response);
          this.initBusiness(response.business);
          this.$Progress.finish();
          this.Invoice = response.data;
          document.title = `${this.currentBusiness.name} - Invoice # ${this.Invoice.localId}`;
          if (this.currentBusiness.metadata.invoiceLimit)
            this.linkExpired = this.$moment(
              this.currentBusiness.metadata.invoiceLimit
            ).isAfter(this.Invoice.date);
          this.isLoading = false;
        });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);
      // console.log('invoice id', id[0])
      // return invoiceService.getById(id, { invoice: true }).then((response) => {
      return invoiceService.getById(id[0]).then((response) => {
        console.log("response", response);
        this.Invoice = response.data;
        if (this.Invoice?.Customer?.email) {
          this.showEmailBtn = true;
        }
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  /* canvas {
    margin: 5px auto;
    display: block;
    border: 1px solid #ccc;
    padding: 10px;
  } */

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

@media print {
  .printingColor {
    color: black !important;
  }
}
.avoid-page-break {
  page-break-inside: avoid;
  break-inside: avoid;
}


/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
